import Vue from "vue";
import Router from "vue-router";

import menuRouter from "./menuRoutes";

Vue.use(Router);

const router = new Router({
  routes: [
    menuRouter,
    {
      path: "/login",
      name: "登录",
      component: () => import("../views/login/login"),
    },
    {
      path: "/interview/detail",
      name: "面试者详情",
      component: () => import("../views/detail.vue"),
    },
    {
      path: "/error",
      name: "500",
      component: () => import("../views/error/500"),
    },
    {
      path: "/notFound",
      name: "404",
      component: () => import("../views/error/404"),
    },
    { path: "*", redirect: "/notFound", hidden: true },
  ],
});
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("ch_token");
  if (!token && to.path != "/login") {
    // token 验证
    next("/login");
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
    next();
  }
});
export default router;
